import { render, staticRenderFns } from "./download.vue?vue&type=template&id=bcf23260&scoped=true"
import script from "./download.vue?vue&type=script&lang=js"
export * from "./download.vue?vue&type=script&lang=js"
import style0 from "./download.vue?vue&type=style&index=0&id=bcf23260&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf23260",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\project\\fashang\\cqykdx\\student_pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bcf23260')) {
      api.createRecord('bcf23260', component.options)
    } else {
      api.reload('bcf23260', component.options)
    }
    module.hot.accept("./download.vue?vue&type=template&id=bcf23260&scoped=true", function () {
      api.rerender('bcf23260', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/app/download.vue"
export default component.exports